import $ from 'jquery';
import {getCookie, setCookie} from './cookies.js';

class FavoritePropertiesLinks {
    constructor(links) {
        this.$links = $(links);
        
        this._init();
    }

    _init() {
        if(this.$links.length) {
            this._bindEvents();
        }
    }

    _bindEvents() {
        this.onFavoritePropertyLinkToggleFn = this._onFavoritePropertyLinkToggle.bind(this);

        this.$links.on('click', this.onFavoritePropertyLinkToggleFn);
    }

    _onFavoritePropertyLinkToggle(e) {
        e.preventDefault();
        console.log('_onFavoritePropertyLinkToggle');
        let $target = $(e.target);
        
        if(!$target.hasClass('favorite-properties-link')) {
            $target = $target.parents('.favorite-properties-link');
        }

        if($target.length) {
            const propertyId = $target[0].hasAttribute('data-id') ? $target.attr('data-id') : null;

            if(propertyId) {
                if($target.hasClass('favorite-properties-link--active')) {
                    this._updateList(propertyId, 'remove', $target);
                }
                else {
                    this._updateList(propertyId, 'add', $target);
                }
            }
        }
    }

    _updateList(id, action, $target) {
        let favoritePropertiesList = getCookie('bas_favorite_properties');

        if(favoritePropertiesList) {
            favoritePropertiesList = JSON.parse(favoritePropertiesList);
        }
        
        if(!Array.isArray(favoritePropertiesList)) {
            favoritePropertiesList = [];
        }

        favoritePropertiesList = new Set([...favoritePropertiesList]);

        if(action === 'add' && !favoritePropertiesList.has(id)) {
            favoritePropertiesList.add(id);
            $target.addClass('favorite-properties-link--active');
        }
        else if(action === 'remove' && favoritePropertiesList.has(id)) {
            favoritePropertiesList.forEach((propertyId) => {
                if(propertyId === id) {
                    favoritePropertiesList.delete(propertyId);
                }
            });
            $target.removeClass('favorite-properties-link--active');
        }

        setCookie('bas_favorite_properties', JSON.stringify([...favoritePropertiesList]), 0);
    }
}

export default FavoritePropertiesLinks;

const FavoriteinitPropertiesLinks = function() {
    const links = document.querySelectorAll('.favorite-properties-link[data-id]');
    
    if(links.length) {
        const instance = new FavoritePropertiesLinks(links);
    }
};

if(document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', FavoriteinitPropertiesLinks);
}
else {
    FavoriteinitPropertiesLinks();   
}